export default "__VITE_ASSET__D5CB7h1D__"